import { Icon } from "@smartsuite/react-ui/lib";
import { type Doc, Editor } from "@smartsuite/smartdoc";
import { calloutTypeIcons } from "@smartsuite/smartdoc/lib/cjs/extensions/callout/constants";
import { type FC, useMemo } from "react";
import { usePublicEditorExtensions } from "../../helpers/publicMentionExtension";
import type { FieldVisibilityCallback } from "../../hooks/useFormFieldVisibility";
import type { FormConfigCalloutItem } from "../../types/form";
import {
  calloutColors,
  calloutContentContainerColor,
  editorExtensions,
} from "./FormCalloutItem.constants";

const calloutEditorExtensions = (): typeof editorExtensions => editorExtensions;

interface FormCalloutItemProps {
  item: FormConfigCalloutItem;
  checkFieldVisibility: FieldVisibilityCallback;
}

export const FormCalloutItem: FC<FormCalloutItemProps> = ({ item, checkFieldVisibility }) => {
  const { calloutType, doc } = item.params;
  const extensions = usePublicEditorExtensions(calloutEditorExtensions);

  const parsedDoc: Doc = useMemo(() => (doc ? JSON.parse(doc) : null), [doc]);

  const isEmpty = useMemo(
    () => (parsedDoc ? !parsedDoc.content.find((content) => !!content.content) : null),
    [parsedDoc],
  );

  if (isEmpty || !calloutType) return null;

  const isItemConditionSatisfied = checkFieldVisibility(item.slug);
  if (!isItemConditionSatisfied) return null;

  return (
    <div
      data-testid="form-callout-item"
      className="form-callout-item"
      style={{
        backgroundColor: calloutContentContainerColor[calloutType].backgroundColor,
        borderColor: calloutContentContainerColor[calloutType].borderColor,
      }}
    >
      <Icon
        name={calloutTypeIcons[calloutType]}
        color={calloutColors[calloutType]}
        dimension={{ height: 16, width: 16 }}
      />
      <Editor initialDoc={parsedDoc} extensions={extensions} editable={false} />
    </div>
  );
};
